import React, { useEffect } from "react";
import TopHeader from "./top-header/TopHeader";
import SearchBox from "./search-box/SearchBox";
import { isMobile } from "react-device-detect";

import "./Header.css";
import Menus from "./menu/Menus";
import { useState } from "react";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import { base_url } from "../../server";
import { useTranslation } from "react-i18next";

function Header({ changeLang }) {
  const [isSticky, setIsSticky] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const baseUrl = base_url();
  const fixedHeader = () => {
    if (window.scrollY >= 80) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };
  window.addEventListener("scroll", fixedHeader);

  const [state, setState] = useState({
    front_top_message: "",
    icon: "",
  });

  const onMenuButtonClicked = () => {
    if (isMobile) {
      setShowMenu(!showMenu);
    }
  };

  const [ourCategoryData, setOurCategoryData] = useState(null);
  const getData = async () => {
    try {
      const res = await axios.get(`${baseUrl}category/public`, {
        withCredentials: true,
      });
      setOurCategoryData(res.data);
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  const { t } = useTranslation();
  const location = useLocation();

  return (
    <>
      {/* <button type="button" onClick={()=>{changeLang('en')}}>EEE</button>
                    <button type="button" onClick={()=>{changeLang('de')}}>ARR</button> */}
      <header
        className={`${
          isSticky
            ? "sticky active"
            : `sticky ${location.pathname === "/" ? "" : "diff"}`
        }`}
      >
        <TopHeader state={state} changeLange={changeLang} />
        <SearchBox val={state} showMenu={onMenuButtonClicked} />
        {!isMobile && (
          <div className="navbarArea">
            <div className="abaris-nav">
              <div className="container-fluid">
                <div className="menuCard">
                  <div className="allCategoryDrop">
                    <span>categories</span>
                    <i className="ri-menu-line"></i>

                    <div className="categoryList">
                      <ul>
                        <li>
                          <Link to="/products">Baby bottles</Link>
                        </li>
                        <li>
                          <Link to="/products">Breastfeeding Accessories</Link>
                        </li>
                        <li>
                          <Link to="/products">Bibs & Cloths</Link>
                        </li>
                        <li>
                          <Link to="/products">Teethers & Pacifiers</Link>
                        </li>
                        <li>
                          <Link to="/products">Feeding Essentials</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </header>
      <div
        className="offcanvas offcanvas-start p-0"
        tabIndex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
      >
        <div className="offcanvas-header">
          <h5
            className="offcanvas-title text-white"
            id="offcanvasScrollingLabel"
          >
            Shop by Category
          </h5>
          <button
            type="button"
            className="btn-close text-white"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <div className="offcanvas-body">
          <div className="categoryItems d-none">
            <ul>
              {ourCategoryData?.map((item, i) => {
                return (
                  <li key={i}>
                    <Link to={`/product/category/${item.uid}/${item?.slug}`}>
                      {item?.name}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="accordion" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Face Wash
                </button>
              </h2>
              <div
                id="collapseOne"
                className="accordion-collapse collapse show"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body p-0">
                  <div className="categoryItems">
                    <ul>
                      <li>
                        <Link to={`/product/category/4/FaceWash`}>
                          Body Serum For Women
                        </Link>
                      </li>
                      <li>
                        <Link to={`/product/category/4/FaceWash`}>
                          True Match Nude
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  Beauty Glow
                </button>
              </h2>
              <div
                id="collapseTwo"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body p-0">
                  <div className="categoryItems">
                    <ul>
                      <li>
                        <Link to={`/product/category/1/BeautyGlow`}>
                          Moisturizer Summer Skin
                        </Link>
                      </li>
                      <li>
                        <Link to={`/product/category/1/BeautyGlow`}>
                          Drop Stitch Wakeboard
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  Body Lotion
                </button>
              </h2>
              <div
                id="collapseThree"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body p-0">
                  <div className="categoryItems">
                    <ul>
                      <li>
                        <Link to={`/product/category/2/BodyLotion`}>
                          100% Body Care
                        </Link>
                      </li>
                      <li>
                        <Link to={`/product/category/2/BodyLotion`}>
                          Dry Skin Moisturizer
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                  aria-expanded="false"
                  aria-controls="collapseFour"
                >
                  Cosmetics
                </button>
              </h2>
              <div
                id="collapseFour"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body p-0">
                  <div className="categoryItems">
                    <ul>
                      <li>
                        <Link to={`/product/category/3/Cosmetics`}>
                          Women Beauty Glow
                        </Link>
                      </li>
                      <li>
                        <Link to={`/product/category/3/Cosmetics`}>
                          ISUP Drop Stitch
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
